export default __webpack_public_path__ + "static/assets/route-generation-syncing.7ba5b140.png";